<script>
export default {
  name: 'franchise-index',
  props: ['view'],
  data() {
    return {
      t: null,
      user: null,
      links: null,
      notices: {
        hurricane_milton: null,
      },
      tutorials: null,
      estimatedBalance: null,
      estimatedEarnings: null,
      funnelOfTheMonth: null,
      isModalLinkOpen: false,
      iconCodeCopyLink: 'b54c',
      gettingStartedLinks: null,
      isModalClickHereOpen: false,
      isModalTutorial: false,
      selectedTutorial: '',
      analytics: {
        loading: false,
        metric: 'all',
        metrics: [],
        chart: {
          max: 0,
          data: null,
          hoveredTab: null,
        },
      },
      referring: {
        loading: false,
        period: 'day',
        periods: [],
        chart: {
          options: {
              min: 0,
              max: 10,
              stepSize: 2
          },
          data: {
            xLabels: [],
            data: [],
            backgroundColor1: 'rgba(0, 114, 225, 1)',
            backgroundColor2: 'rgba(0, 114, 225, 0.85)',
            barPercentage: 0.666666667
          },
          params: {
            bars: [],
            labels: [],
            current: { data: [], pie: {} },
            resume: { data: [], pie: {} },
          }
        },
      },
    }
  },
  created() {
    this.t = this.view.translations
    this.user = this.view.data.user
    this.links = this.view.links
    this.notices = this.view.data.notices
    this.tutorials = this.view.data.tutorials
    this.estimatedBalance = this.view.data.estimated_balance
    this.estimatedEarnings = this.view.data.estimated_earnings
    this.funnelOfTheMonth = this.view.data.funnel_of_the_month
    this.gettingStartedLinks = this.view.data.getting_started_links

    this.analytics.metrics = [
      { label: this.t.access, value: 'clicks', total: '0', formattedTotal: '0', badge:'ba-badge ba-red', class:'', color: '#0080FC', tooltip: this.t.analytics_graph_clicks_tooltip},
      { label: this.t.registration, value: 'registrations', total: '0', formattedTotal: '0', badge:'ba-badge ba-red ba-yellow', class:'', color: '#FEB334', tooltip: this.t.analytics_graph_registries_tooltip},
      { label: this.t.paid_plans, value: 'paid_plans', total: '0', formattedTotal: '0', badge:'ba-badge ba-red ba-purple', class:'', color: '#861196', tooltip: this.t.analytics_graph_paid_plans_tooltip},
      { label: this.t.label_conversions, value: 'conversions', total: '0', formattedTotal: '0', badge:'ba-badge ba-green', class:'', color: '#F93D6F', tooltip: this.t.analytics_graph_conversions_tooltip},
      { label: this.t.trials, value: 'trials', total: '0', formattedTotal: '0', badge: '', class:'no-hover-tab', color: '#C4D1E0', tooltip: this.t.analytics_graph_trials_tooltip},
    ]

    this.referring.periods = [
      { label: this.t.today, value: 'day' },
      { label: this.t.month, value: 'month' },
      { label: this.t.year, value: 'year' },
    ]
  },
  mounted() {
    this.loadAnalyticsData('all')
    this.loadReferringData()
  },
  computed: {
    sponsorName() {
      return this.user.sponsor && this.user.sponsor.hasOwnProperty('nome') ? this.user.sponsor.nome : 'Internet Marketing LLC';
    },
    associateType() {
      return this.user.association && this.user.association.hasOwnProperty('type') ? this.user.association.type : '-';
    },
    associateDate() {
      return this.user.association && this.user.association.hasOwnProperty('date') ? this.user.association.date : '-';
    },
    requestPayoutLink() {
      return this.links.associate_earns + '?openmodal=requestEarnings';
    },
    estimatedBalanceBRL() {
      return this.estimatedBalance.hasOwnProperty('BRL')
              && this.estimatedBalance.BRL.hasOwnProperty('NAO')
              && this.estimatedBalance.BRL.NAO.hasOwnProperty('valor')
            ? this.estimatedBalance.BRL.NAO.valor
            : 0
    },
    estimatedBalanceUSD() {
      return this.estimatedBalance.hasOwnProperty('USD')
              && this.estimatedBalance.USD.hasOwnProperty('NAO')
              && this.estimatedBalance.USD.NAO.hasOwnProperty('valor')
            ? this.estimatedBalance.USD.NAO.valor
            : 0
    },
    estimatedBalanceEUR() {
      return this.estimatedBalance.hasOwnProperty('EUR')
              && this.estimatedBalance.EUR.hasOwnProperty('NAO')
              && this.estimatedBalance.EUR.NAO.hasOwnProperty('valor')
            ? this.estimatedBalance.EUR.NAO.valor
            : 0
    },
    chartAnalyticsIsEmpty() {
      if(!this.analytics.chart.data) {
        return true
      }

      const keys = Object.keys(this.analytics.chart.data);
      const total = Object.values(this.analytics.chart.data)
        .reduce((total, obj, idx) => {
          if (keys[idx] === 'trials') {
            return total;
          }
          return keys[idx] === 'trials' ? total : total + obj.total
        }, 0);

      return total == 0;
    },
    chartAnalyticsData() {

      if(!this.analytics.chart.data) {
        return {labels:[], datasets:[]}
      }

      moment.locale(this.getLocale());
      const months = this.analytics.chart.data.clicks.history.map(item =>
        moment(item.month, 'YYYY-MM').format('MMM')
      );

      let datasets = [];
      let showAll = !this.analytics.chart.hoveredTab || this.analytics.chart.hoveredTab === 'trials'

      if (showAll || this.analytics.chart.hoveredTab === 'clicks') {
        datasets.push({
          label: this.t.access,
          data: this.analytics.chart.data.clicks.history.map(item => item.qty),
          fill: false,
          borderColor: this.analytics.metrics[0].color,
          //backgroundColor: this.createGradientAnalytic,
          // pointBackgroundColor: '#FA4B57',  // red
          pointRadius: 0.5,
          pointStyle: 'circle',
          // showLine: true,
          borderWidth: 0
        });
      }

      if (showAll || this.analytics.chart.hoveredTab === 'registrations') {
        datasets.push({
          label: this.t.registration,
          data: this.analytics.chart.data.registrations.history.map(item => item.qty),
          fill: false,
          borderColor: this.analytics.metrics[1].color,
          //backgroundColor: this.createGradientAnalytic,
          // pointBackgroundColor: '#FFCC3F',  // yellow
          pointRadius: 0.5,
          pointStyle: 'circle',
          borderWidth: 0
        });
      }

      if (showAll || this.analytics.chart.hoveredTab === 'paid_plans') {
        datasets.push({
          label: 'Paid Plans',
          data: this.analytics.chart.data.paid_plans.history.map(item => item.qty),
          fill: false,
          borderColor: this.analytics.metrics[2].color,
          //backgroundColor: this.createGradientAnalytic,
          // pointBackgroundColor: '#7E1AFD',  // purple
          pointRadius: 0.5,
          pointStyle: 'circle',
          borderWidth: 0
        });
      }

      if (showAll || this.analytics.chart.hoveredTab === 'conversions') {
        datasets.push({
          label: this.t.label_conversions,
          data: this.analytics.chart.data.conversions.history.map(item => item.qty),
          fill: false,
          borderColor: this.analytics.metrics[3].color,
          // backgroundColor: this.createGradientAnalytic,
          // pointBackgroundColor: '#20E4B3',  // green
          pointRadius: 0.5,
          pointStyle: 'circle',
          borderWidth: 0
        });
      }

      return {
        labels: months,
        datasets: datasets
      };
    },
    chartAnalyticsOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        hover: {
          mode: false
        },
        scales: {
          xAxes: [
            {
              stacked: false,
              ticks: {
                stepSize: 1
              },
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                borderDash: [1, 2],
                drawBorder: false
              },
              stacked: false,
              ticks: {
                min: 0,
                max: this.analytics.chart.max,
                beginAtZero: true
              }
            }
          ]
        }
      };
    }
  },
  methods: {
    getLocale() {
      lang = typeof lang == 'undefined' ? navigator.language : lang

      switch (lang) {
        case 'br':
          lang = 'pt-BR'
          break
        case 'us':
          lang = 'en-US'
          break
        default:
          break
      }

      return lang
    },
    copyToClipboard(text) {

      // Navigator clipboard api needs a secure context (https)
      if (navigator.clipboard && window.isSecureContext)
      {
        navigator.clipboard.writeText(text.trim())
        .then(() => {
          alertMsg("success", this.t.copied);
        })
        .catch(err => {
          console.error(this.t.error_on_copy_associate_link_to_clipboard, text, err);
        });
      }
      else
      {
        let _input = document.createElement('input');

        document.body.appendChild(_input);
        _input.value = text.trim();
        _input.select();

        try
        {
          document.execCommand('copy');
          alertMsg("success", this.t.copied);
        }
        catch (err)
        {
          console.error('Error on copy text to clipboard: ', text, err);
        }
        finally
        {
          document.body.removeChild(_input)
        }
      }
    },
    copyLink() {
      try{
        const linkElement = document.getElementById('associateLink');
        const linkText = linkElement.innerText;

        const tempInput = document.createElement('input');
        tempInput.value = linkText;
        document.body.appendChild(tempInput);

        tempInput.select();

        const succesful = document.execCommand('copy');

        document.body.removeChild(tempInput);

        if(succesful){
          this.changeIcon();
        }
      } catch(error){
        console.log('Erro ao copiar o link', error)
        alertMsg('error', 'Error on copy associate link to clipboard.');
      }
    },
    changeIcon(){
      this.iconCodeCopyLink = 'ad00';
      setTimeout(() => {
        this.iconCodeCopyLink = 'b54c';
      }, 1000);
    },
    openModalClickHere(){
      this.isModalClickHereOpen = true;
    },
    closeModalClickHere(){
      this.isModalClickHereOpen = false;
    },
    openModalTutorial(){
      this.isModalTutorial = true;
    },
    closeModalTutorial(){
      this.isModalTutorial = false;
    },
    selectAnalyticsTab: function(metric) {
      if(this.analytics.metric === metric) {
        return this.clearHoveredTab();
      }

      this.analytics.metric = metric;
      this.setHoveredTab(metric);
    },
    setHoveredTab(tab) {
      this.analytics.chart.hoveredTab = tab;
    },
    clearHoveredTab() {
      this.analytics.metric = 'all';
      this.analytics.chart.hoveredTab = null;  // Show all series data
    },
    loadAnalyticsData(metric = this.analytics.metric) {
      this.analytics.loading = true;
      this.analytics.metric = metric;

      let apiUrl = this.links.url_office_api + `/v1/associate/analytics/${metric}/summary`

      let self = this;
      axios
        .get(apiUrl, {
          headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + this.user.token_msu
          }
        })
        .then(res => {
          if(res.data.success) {
            self.setAnalyticsData(metric, res.data.data)
          }
        })
        .catch(e => console.log('error = ', e))
        .finally(() => self.analytics.loading = false);
    },
    setAnalyticsData: async function(metric, data) {
      if(metric == 'all') {
        this.analytics.metrics.forEach(metric => {
          this.setAnalyticsData(metric.value, data[metric.value]);

          let maxQty = data[metric.value].history.reduce((max, item) => {
            return item.qty > max ? item.qty : max;
          }, 0);

          // update analytics chart max value
          if(metric.value !== 'trials' && maxQty > this.analytics.chart.max)  {
            this.$set(this.analytics.chart, 'max', maxQty);
          }

        });
        this.$set(this.analytics.chart, 'data', data);
        return this.selectAnalyticsTab('all');
      }

      let idx = this.analytics.metrics.findIndex(m => m.value === metric);

      if(idx !== -1) {
        this.$set(this.analytics.metrics[idx], 'total', data.total);
        this.$set(this.analytics.metrics[idx], 'formattedTotal', this.formatAnalyticMetricTotal(data.total));
      }
    },
    formatAnalyticMetricTotal(total) {
      return total >= 1000
        ? Math.floor(total / 1000) + 'K'
        : total;
    },
    createGradientAnalytic(ctx) {
      const canvas = ctx.chart.ctx;
      const gradient = canvas.createLinearGradient(0, 0, 0, 350);

      gradient.addColorStop(0, 'rgba(77, 83, 246, 1)');
      gradient.addColorStop(1, 'rgba(77, 83, 246, 0)');

      return gradient;
    },
    getXLabelAndSetTableData: function (event, activeElements) {
      if (activeElements.length > 0)
      {
        // get active chart element
        let elt = activeElements[0];

        // retrieve element label
        let lbl = elt._model.label;

        // bar hovered

        if(lbl !== this.referring.chart.params.current.label)
        {
          let res = this.referring.chart.params.bars.find(el => el.label === lbl);
          if(res !== undefined)
          {
            this.show( res )
          }
        }
      }
      else
      {
        // hover another place or bar empty
        if(this.referring.chart.params.current.data.length > 0)
        {
          // this.show( { data: [], pie: {} } )
          this.show()
        }
      }
    },
    selectReferringTab(period) {
      if(!this.referring.loading) {
        this.referring.period = period;
        this.loadReferringData();
      }
    },
    loadReferringData: async function(period = this.referring.period) {
      this.referring.loading = true;
      this.referring.period = period;

      let apiUrl = this.links.url_office_api + `/v1/associate/analytics/${period}/disclosure`

      try
      {
        let res = await axios.get(apiUrl, {
                          headers: {
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + this.user.token_msu
                          }
                        })

        // just sanitize array of data
        let data = res.data.data.map(
            v => ({
              ...v,
              url: v.url.replace(/https?\:\/\//, ""),
              total: Number(v.total),
              access: Number(v.access),
              conversions: Number(v.conversions)
            })
        );

        // history grouped by label
        data = this.sortHistory(data);
        let history = this.groupBy(data, 'label')

        let bars = this.makeBars(period, history); // obtem somatorio dos valores das barras

        // obtem o maior valor da lista para delimitar o maximo do grafico
        let max = bars.reduce(
          (c, { total }) => (total > c ? total : c),
          0
        );
        if (max < 10) {
          max = 10;
        }

        // calcula o percentual da barra no grafico
        let barsWithPercent = bars.map(
          b => ({
            bar: `calc(calc(100% - 20px) * ${max &&
              b.total / max})`, // tamanho da barra em %
            pie: {
              access: `${b.total &&
                (b.access / b.total) * 100}%`,
              conversions: `${b.total &&
                (b.conversions / b.total) * 100}%`
            }, // percentual no grafico de pizza
            ...b
          })
        );

        // calculando labels do eixo y do grafico
        let tick = 5;
        let unit = max / tick;
        let labels = [];
        for (let i = 0; i <= tick; i++) {
          labels.unshift(Math.floor(i * unit));
        }

        // history grouped by url
        let historyByUrl = this.groupBy(data, 'url');

        // totaliza as ocorrencias por url
        let urls = this.sortHistory(
          this.objMap(
            historyByUrl,
            s =>
              s.reduce(
                (c, v) => ({
                  url: v.url,
                  total: c.total + v.total,
                  access: c.access + v.access,
                  conversions: c.conversions + v.conversions
                }),
                { total: 0, access: 0, conversions: 0 }
              )
          )
        );

        // faz o somatorio geral das urls
        let total = urls.reduce(
            (c, v) => ({
              total: c.total + v.total,
              access: c.access + v.access,
              conversions: c.conversions + v.conversions
            }),
            { total: 0, access: 0, conversions: 0 }
        );

        // calcula resumo (barra mostrada no hover)
        let resume = {
            data: urls,
            pie: { // calcula percentual no grafico de pizza
              access: `${total.total &&
                (total.access / total.total) * 100}%`,
              conversions: `${total.total &&
                (total.conversions / total.total) * 100}%`
            }
        };

        // change y axis
        this.$set(this.referring.chart.options, 'max', max);
        this.$set(this.referring.chart.options, 'stepSize', unit);

        // change x axis
        let xLabels = bars.map(obj => obj.label)
        this.$set(this.referring.chart.data, 'xLabels', xLabels);

        // set bar color
        if(period == 'day')
        {
          this.referring.chart.data.backgroundColor = '#FFDF34'
          this.referring.chart.data.barPercentage = 0.666666667
        }
        else if(period == 'month')
        {
          this.referring.chart.data.backgroundColor = '#1665d8'
          this.referring.chart.data.barPercentage = 0.666666667
        }
        else
        {
          this.referring.chart.data.backgroundColor = '#F24988'
          this.referring.chart.data.barPercentage = 0.28
        }

        // fill bars
        this.$set(this.referring.chart.data, 'data', bars.map(obj => obj.total))

        this.referring.chart.params.bars = barsWithPercent;
        this.referring.chart.params.labels = labels;
        this.referring.chart.params.resume = resume;
        this.show();
      }
      catch (e)
      {
        console.log('error = ', e)
      }
      finally
      {
        this.referring.loading = false
      }
    },
    sortHistory(list) {
        let values = [];
        values = Array.isArray(list) ? list : Object.values(list);

        return values.sort((a, b) => {
          if (a.conversions > b.conversions) return -1;
          if (a.conversions < b.conversions) return 1;
          if (a.access > b.access) return -1;
          if (a.access < b.access) return 1;
          return 0;
        });
    },
    makeBars(period, data) {
        // obtem somatorio dos valores das barras
        let count,
          name,
          format,
          find,
          fix = 0;

        switch (period) {
          case 'day':
            count = 24;
            name = 'hour';
            format = 'HH';
            find = 'DD-HH';
            fix = -1;
            break;

          case 'month':
            count = 30;
            name = 'day';
            format = 'DD';
            find = 'MM-DD';
            fix = -1;
            break;

          default:
            count = 12;
            name = 'month';
            format = 'MMM';
            find = 'YYYY-MM';
            fix = -1;
            break;
        }
        return Array.apply(null, Array(count)).map((v, i) => {
          const month = count - i;
          let label = moment().subtract(month + fix, name);
          let h = data[label.format(find)] || [];

          // faz somatorio do array de itens do periodo
          let value = h.reduce(
            (c, v) => ({
              total: c.total + v.total,
              access: c.access + v.access,
              conversions: c.conversions + v.conversions
            }),
            { total: 0, access: 0, conversions: 0 }
          );

          return {
            label: label.format(format),
            ...value,
            data: h
          };
        });
    },
    groupBy(arr, groupByKey) {
      let obj = {};

      for(let key in arr) {
        if( obj[ arr[key][groupByKey] ] === undefined ) {
          obj[ arr[key][groupByKey] ] = [];
        }
        obj[ arr[key][ groupByKey ] ].push(arr[key])
      }

      return obj;
    },
    objMap(obj, callback) {
      let local = [];

      for(let key in obj) {
        local.push( callback(obj[key]) );
      }

      return local
    },
    show(v = this.referring.chart.params.resume ) {
      this.$set(this.$data.referring.chart.params, 'current', JSON.parse(JSON.stringify(v)));
    },
    changeSelectedTutorial(tutorialData){
    this.selectedTutorial = tutorialData;
  }
  }
}
</script>

<template>
  <div>
    <div v-if="notices.hurricane_milton" class='ba-alert ba-info ba-mg-b-1'>
        <span>{{ notices.hurricane_milton }}</span>
    </div>
    <div class="ba-card ba-mg-b-1">
        <div class="ba-top">
          <span class="ba-title ba-flex ba-jc-sb">
              <span class="ba-flex ba-gp-1 ba-ai-center">{{t.label_welcome}}</span>
              <div class="ba-box-items ba-flex ba-jc-fe ba-gp-1">
                <a data-toggle="modal" data-target="#associateLinkModals" class="ba-w-100" style="border: none; background: none;">
                  <button class="ba-btn ba-md ba-blue">
                    <span class="no-text-transform">{{t.affiliate_link}}</span>
                  </button>
                </a>
                <div id="associateLinkModals" class="modal fade">
                    <div class="modal-dialog ba-flex ba-jc-center" style="width: 100% !important;">
                      <div class="modal-content ba-card ba-w-100" style="border-radius: 16px; margin-top: 8rem; width: 50% !important;">
                        <div class="ba-top ba-pd-x-1 ba-flex ba-jc-sb">
                            <span class="ba-title">
                              <span class="ba-color-blue19">{{t.affiliate_link}}</span>
                            </span>
                            <div class="ba-box-items ba-flex ba-jc-fe">
                              <button data-dismiss="modal" class="ba-btn ba-btn-close ba-sm ba-rounded">
                                  <builderall-icon code="64f7" />
                              </button>
                            </div>
                        </div>
                        <div class="ba-content ba-pd-x-1 ba-mg-b-1 ba-w-100">
                            <div class="content_associate_link">
                              <div class="ba-grid">
                                <span class="ba-flex ba-mg-b-1 ba-ai-center">
                                  <span class="ba-montserrat-700" style="margin-right: 8px;">{{t.affiliate_link}}:</span>
                                  <a id="associateLink" class="url_associate">{{ user.association.link }}</a>
                                  <button @click="copyLink" class="button_copy_link">
                                    <builderall-icon :code="iconCodeCopyLink"/>
                                  </button>
                                </span>
                                <span class="ba-flex">
                                  <span class="ba-montserrat-700" style="margin-right: 8px;">{{t.associate_id}}:</span>
                                  <span class="ba-montserrat-500">{{user.association.id}}</span>
                                </span>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <a :href="links.resources" target="_blank" class="ba-btn ba-md ba-blue">
                  <span class="ba-text-capitalize">{{t.label_resources}}</span>
                </a>
              </div>
          </span>
        </div>
        <div class="ba-content ba-w-100">
          <div class="ba-flex ba-jc-sb">
            <div class="content_img ba-flex ba-ai-center ba-mg-l-1 ba-mg-r-3">
              <img :src="user.avatar"/>
            </div>
            <hr class="hr_column">
            <div class="ba-w-50">
              <div class="ba-grid ba-pd-y-1">
                <span class="ba-title ba-mg-b-1">{{t.associate_information}}</span>
                <div class="ba-content ba-grid">
                    <div class="ba-top ba-pd-t-1">
                      <div class="ba-title ba-flex ba-jc-sb">
                        <h3 class="ba-mulish-200">{{t.associate_status}}</h3>
                        <h3 class="ba-flex ba-jc-fe">{{ associateType }} </h3>
                      </div>
                    </div>
                    <div class="ba-top">
                      <div class="ba-flex ba-jc-sb">
                        <h3 class="ba-mulish-200">{{t.sponsor}}</h3>
                        <h3 class="ba-flex ba-jc-fe"> {{ sponsorName }} </h3>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <hr class="hr_column">
            <div class="ba-flex ba-jc-fe ba-ai-center">
              <div class="content_img_need_help">
                <div class="ba-flex ba-gp-1 ba-jc-center ba-pd-x-1">
                    <div class="ba-grid">
                      <img class="img_need_help" src="/internacional/public/franchise/img/Group.svg" />
                      <div class="ba-grid">
                        <span class="text_help">{{t.need_help_getting_started}}</span>
                        <a class="button_click_here" data-toggle="modal" data-target="#getStartedModalDisabled">
                          <span>
                            {{t.label_tooltip_soon}}
                            <!-- {{t.click_here}} -->
                          </span>
                          <builderall-icon code="arrow-right"/>
                        </a>
                        <div id="getStartedModal" class="modal fade">
                          <div class="modal-dialog ba-w-75 ba-flex ba-gp-1 ba-jc-center ba-ai-center" style="padding-top: 10rem;">
                            <div class="modal-content ba-card ba-w-100 ba-mg-t-4" style="border-radius:16px !important;">
                                <div class="ba-top ba-flex ba-jc-sb ba-w-100" style="gap: 0px!important" >
                                  <div class="ba-flex" style="justify-content: center !important; margin-top: -195px !important;">
                                    <div class="img_overlay_click_here">
                                      <img style="height: 300px;" src="/internacional/public/franchise/img/Group.svg" />
                                    </div>
                                  </div>
                                    <div class="ba-box-items ba-flex ba-jc-fe ba-gp-1">
                                      <button data-dismiss="modal" class="ba-btn ba-btn-close ba-sm ba-rounded" style="position: fixed !important;">
                                          <builderall-icon code="64f7" />
                                      </button>
                                    </div>
                                </div>
                                <div class="ba-content ba-w-100">
                                    <div class="ba-flex ba-gp-1 ba-jc-center">
                                      <div class="ba-grid ba-mg-b-2">
                                        <h4 style="font-size: 32px !important;margin-bottom: 1rem !important;color: #4D5D71 !important;font-weight: 700 !important; font-family: 'Montserrat';">
                                          {{t.need_help_getting_started}}</h4>
                                        <div class="ba-grid ba-gp-1">
                                          <a
                                            v-for="(link, index) in gettingStartedLinks"
                                            :key="index"
                                            :href="link.url"
                                            class="ba-btn ba-md ba-blue no-text-transform"
                                            target="_blank"
                                          >
                                            <span class="ba-montserrat-500">{{link.title}}</span>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="ba-card-grid ba-mg-b-1 ba-w-100 analytics-infos">
      <div class="ba-card ba-w-100">
          <div class="ba-top">
            <div class="ba-flex ba-ai-fs ba-gp-02 ba-title">
              <span >{{ t.analytics }}</span>
              <builderall-icon
                code='help'
                ba-tooltip-position='bottom'
                ba-tooltip-color='dark'
                :ba-tooltip-title="t.data_updated_every_24_hours"
                style="--builderall-icon-size: 15px; --builderall-icon-color: #95ACCC;">
              </builderall-icon>
          </div>
          </div>
          <div class="ba-content">
            <div class="ba-graphic-card ba-w-100 ba-flex">
              <builderall-loader :loading="analytics.loading">
                <div class="filter-group">
                  <div
                    v-for="(metric, index) in analytics.metrics"
                    :key="index"
                    :style="{borderColor: metric.color}"
                    class="ba-flex filter"
                    :class="{[metric.class]: true, 'activated': metric.value === analytics.metric || metric.value == 'trials'}"
                    @click.prevent="selectAnalyticsTab(metric.value)"
                    ba-tooltip-position="bottom"
                    :ba-tooltip-title="metric.tooltip"
                  >
                    <div class="ba-grid ba-mulish-700" style="padding: 0 4px">
                      <span
                        class="ba-flex ba-jc-center"
                        :style="{ color: metric.color, whiteSpace: 'nowrap' }"
                      >
                        {{ metric.label }}
                      </span>
                      <span
                        class="ba-flex ba-jc-center"
                        :class="{'no-hover-tab': metric.value == 'trials'}"
                        :style="{color: '#3B5487'}"
                        :data-formatted-total="metric.formattedTotal"
                      >
                        {{ metric.total }}
                      </span>
                    </div>
                  </div>
              </div>
            </builderall-loader>

            <div class="ba-w-100">
              <builderall-loader :loading="analytics.loading">
                <builderall-empty-image v-if="chartAnalyticsIsEmpty"/>
                <line-chart v-else
                  :chartData="chartAnalyticsData"
                  :options="chartAnalyticsOptions"
                  :height="300"
                />
              </builderall-loader>
            </div>

            </div>
          </div>
      </div>
      <div class="ba-card ba-flex ba-w-100">
          <div class="ba-top">
              <span class="ba-title">{{t.estimated_balance}}</span>
          </div>
          <div class="ba-content ba-w-100">
              <div class="ba-grid">
                <div class="ba-flex ba-jc-sb ba-w-100" style="padding-top: 1.2rem; padding-bottom: 1.2rem">
                  <div class="ba-flex ba-pd-r-3">
                    <button class="ba-btn ba-md ba-rounded">
                      <builderall-icon code="e35b" style="builderall-icon{
                          --builderall-icon-size: 50px;
                          --builderall-icon-color: #0080FC;
                      }"/>
                    </button>
                    <h5 class="ba-mg-l-1 ba-mulish-100">USD</h5>
                  </div>
                  <div class="ba-flex ba-jc-fe">
                    <h2 class="ba-data ba-montserrat-700">${{estimatedBalanceUSD}}</h2>
                  </div>
                </div>
                <hr class="ba-hr-row">
                <div class="ba-flex ba-jc-sb ba-w-100" style="padding-top: 1.2rem; padding-bottom: 1.2rem">
                  <div class="ba-flex ba-pd-r-3">
                    <button class="ba-btn ba-md ba-rounded">
                        <builderall-icon code="money-bag-eur" style="builderall-icon{
                            --builderall-icon-size: 50px;
                            --builderall-icon-color: #0080FC;
                        }"/>
                    </button>
                      <h5 class="ba-mg-l-1 ba-mulish-100">EUR</h5>
                    </div>
                    <div class="ba-flex ba-jc-fe">
                      <h2 class="ba-data ba-montserrat-700">€{{estimatedBalanceEUR}}</h2>
                    </div>
                </div>
                <hr class="ba-hr-row">
                <div class="ba-flex ba-jc-sb ba-w-100" style="padding-top: 1.2rem; padding-bottom: 1.2rem">
                    <div class="ba-flex ba-pd-r-3">
                      <button class="ba-btn ba-md ba-rounded">
                          <builderall-icon code="balance" style="builderall-icon{
                              --builderall-icon-size: 50px;
                              --builderall-icon-color: #0080FC;
                          }"/>
                      </button>
                      <h5 class="ba-mg-l-1 ba-mulish-100">BRL</h5>
                    </div>
                    <div class="ba-flex ba-jc-fe">
                      <h2 class="ba-data ba-montserrat-700">R${{estimatedBalanceBRL}}</h2>
                    </div>
                </div>
                <div class="ba-flex ba-gp-1 ba-jc-center ba-mg-t-1">
                  <a :href="requestPayoutLink" class="ba-btn ba-md ba-blue" target="_blank">
                      <span class="ba-text-capitalize">{{t.request_payout}}</span>
                  </a>
                </div>
              </div>
          </div>
      </div>
    </div>
    <div class="ba-card ba-mg-b-1">
          <div class="ba-top">
              <span class="ba-title">{{t.info_30_day_earnings_estimate}}</span>
          </div>
          <div class="ba-content ba-flex ba-jc-sb ba-w-100">
            <div class="ba-card ba-statistics ba-300 ba-shadow-8 ba-mg-y-2">
                <div class="ba-top">
                    <span class="ba-icon">
                        <builderall-icon code="balance" />
                    </span>
                    <span class="ba-title">BRL</span>
                </div>
                <div class="ba-content ba-pd-b-1">
                  <h2 class="ba-data ba-montserrat-700">R${{estimatedEarnings.commission_previous_BRL}}</h2>
                </div>
            </div>
            <hr class="hr_column_card_earnings">
            <div class="ba-card ba-statistics ba-300 ba-shadow-8 ba-mg-y-2">
                <div class="ba-top">
                    <span class="ba-icon">
                        <builderall-icon code="money-bag-eur" />
                    </span>
                    <span class="ba-title">EUR</span>
                </div>
                <div class="ba-content ba-pd-b-1">
                      <h2 class="ba-data ba-montserrat-700">€{{estimatedEarnings.commission_previous_EUR}}</h2>
                </div>
            </div>
            <hr class="hr_column_card_earnings">
            <div class="ba-card ba-statistics ba-300 ba-shadow-8 ba-flex ba-jc-fe ba-mg-y-2">
                <div class="ba-top">
                    <span class="ba-icon">
                      <builderall-icon code="e35b"/>
                    </span>
                    <span class="ba-title">USD</span>
                </div>
                <div class="ba-content ba-pd-b-1">
                    <h2 class="ba-data ba-montserrat-700">${{estimatedEarnings.commission_previous_USD}}</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="ba-card ba-mg-b-1">
        <div class="ba-top">
            <span class="ba-title">{{t.funnel_of_the_month}}</span>
        </div>
        <div class="ba-content ba-grid ba-w-100">
          <div class="ba-w-100 ba-flex ba-custom-scroll">
            <div
              v-for="(funnel, index) in funnelOfTheMonth.slides"
              :key="index"
              class="ba-hr-conditional ba-flex ba-w-100">
              <div id="funnel-of-the-month-card" class="ba-card ba-shadow-8 ba-shadow-hover-8 ba-flex">
                <div class="ba-flex ba-jc-sb ba-w-100">
                  <div class="img-container">
                    <img :src="funnel.thumb.img" class="ba-w-100">
                  </div>
                  <div class="ba-jc-fe ba-flex infos-container">
                    <div class="ba-grid ba-w-100 ba-pd-l-2">
                      <span class="ba-mulish-300">{{funnel.subtitle}}</span>
                      <span class="ba-flex">
                        <h2 class="ba-mulish-900">
                          {{funnel.value}}
                          <span> {{funnel.cycle}}</span>
                        </h2>
                      </span>
                      <a
                        class="ba-btn ba-md ba-blue ba-mg-b-1"
                        target="_blank"
                        :href="funnel.url"
                        style="max-height: 38px"
                      >
                        <span class="no-text-transform">{{t.preview_link}}</span>
                      </a>
                      <button
                        class="ba-btn ba-md ba-green ba-text-capitalize" style="max-height: 38px"
                        @click="copyToClipboard(funnel.url)"
                      >
                        <span class="no-text-transform"> {{t.label_copy_link}} </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
             <hr class="ba-hr-column" :class="[funnelOfTheMonth.slides.length === 2 ? 'm-50' : 'm-16']">
            </div>
          </div>
          <div class="ba-flex ba-jc-sb ba-mg-r-1">
            <div class="ba-flex ba-jc-fe ba-w-100 ba-pd-y-1">
              <a :href="links.associate_funnels" class="button_card_funnel">
                {{t.view_all_funnels}}
              </a>
            </div>
          </div>
        </div>
    </div>
    <!-- <div class="ba-card ba-mg-b-1">
        <div class="ba-top">
            <span class="ba-title">{{ t.tutorial }}</span>
        </div>
        <div class="ba-content ba-w-100" style="box-sizing: border-box;">
          <div class="ba-flex ba-jc-sb ba-mg-x-1 ba-gp-2">
              <div
                v-for="(tutorial, index) in tutorials"
                :key="index"
                class="ba-card ba-no-padding ba-shadow-hover-8 tutorial-card ba-w-100" style="border-radius: 19px !important;">
                <a data-toggle="modal" data-target="#tutorialModalsDisabled" class="ba-w-100" style="border: none; background: none;">
                    <div class="ba-image ba-w-100" style="height: 280px; background-color: rgba(89, 89, 89, 0.40);" @click="changeSelectedTutorial(tutorial)">
                        <!-- :alt="tutorial.title" -- >
                        <img
                          class="ba-w-100 ba-h-100"
                          src="https://storage.builderall.com//franquias/2/7291108/editor-html/12769555.png"
                        >
                      <!-- <iframe
                        src="tutorial.url"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        style="width: 234px; height: 280px; background-color: rgba(89, 89, 89, 0.40); border-top-left-radius: 16px; border-top-right-radius: 16px;"
                    ></iframe> -- >
                    </div>
                </a>
                <div class="ba-flex ba-pd-b-1">
                  <span class="ba-title">
                    {{ t.label_tooltip_soon }}
                    <!-- {{ tutorial.title }} -- >
                  </span>
                </div>
                 <!-- TODO @Guilherme -- >
                  <div id="tutorialModals" class="modal fade">
                    <div class="modal-dialog ba-flex ba-jc-center" style="width: 100% !important;">
                      <div class="modal-content ba-card" style="border-radius: 10px; margin-top: 8rem; width: 55%!important;">
                          <div class="ba-flex ba-jc-center ba-ai-center ba-w-100">
                              <div class="ba-flex ba-jc-center ba-text-center">
                                <span class="ba-montserrat-700">{{ selectedTutorial.title }}</span>
                              </div>
                              <div class="ba-box-items ba-flex ba-jc-fe" style="position: absolute;right: 18px;top: 12px;">
                                <button class="ba-btn ba-btn-close ba-sm ba-rounded" data-dismiss="modal">
                                    <builderall-icon code="64f7" />
                                </button>
                              </div>
                          </div>
                          <div class="ba-content ba-w-100">
                            <div class="ba-mg-x-1 ba-pd-b-1">
                                <iframe
                                  :src="selectedTutorial.url"
                                  frameborder="0"
                                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                  allowfullscreen
                                  class="ba-w-100"
                                  style="background-color: rgba(89, 89, 89, 0.40); border-radius: 10px; height: 52vh;"
                              ></iframe>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
    </div> -->
    <div class="ba-card">
      <div class="ba-flex ba-w-100">
        <div class="ba-container">
          <div class="ba-top ba-mg-t-1 ba-flex ba-jc-sb">
              <div class="ba-title">
                <span class="ba-mg-r-1">{{t.referring_chart.fs5_disclosure_title}}</span>
                <span class="ba-mulish-600">{{ t.referring_chart.fs_disclosure_left_subtitle }}</span>
              </div>
              <div class="ba-box-items ba-flex ba-jc-fe">
                <div class="ba-box-tabs">
                  <a
                    v-for="(tab, index) in referring.periods"
                      :key="index"
                      href="#"
                      class="ba-tab"
                      :class="{ 'ba-is-active': tab.value === referring.period }"
                      @click.prevent="selectReferringTab(tab.value)"
                    >
                    {{ tab.label }}
                  </a>
                </div>
              </div>
          </div>
          <div class="ba-content">
            <builderall-loader :loading="referring.loading">
              <builderall-empty-image v-if="!referring.loading && referring.chart.params.resume.data.length === 0"/>
              <bar-chart v-else
                :chartData="{
                    labels: referring.chart.data.xLabels,
                    datasets: [
                      {
                        label: t.referring_chart.label,
                        borderRadius: 3,
                        backgroundColor: (ctx) => {
                            const canvas = ctx.chart.ctx;
                            const gradient = canvas.createLinearGradient(0, 0, 0, ctx.chart.height);
                            gradient.addColorStop(0, referring.chart.data.backgroundColor1);
                            gradient.addColorStop(1, referring.chart.data.backgroundColor2);
                            return gradient;
                        },
                        data: referring.chart.data.data,
                        barPercentage: referring.chart.data.barPercentage,
                        categoryPercentage: 0.32
                      }
                    ]
                  }"
                  :options="{
                    responsive: true,
                    maintainAspectRatio: false,
                    onHover: getXLabelAndSetTableData,
                    cornerRadius: 10,
                    fullCornerRadius: true,
                    legend: {
                      align: 'start',
                      display: false,
                      labels: {
                        boxWidth: 10,
                        fontFamily: 'Lato',
                        fontSize: 14,
                        fullWidth: false
                      }
                    },
                    scales: {
                      yAxes: [{
                        gridLines: {
                          borderDash: [1,2],
                          drawBorder: false,
                        },
                        ticks: {
                          min: referring.chart.options.min,
                          max: referring.chart.options.max,
                          stepSize: referring.chart.options.stepSize
                        }
                      }],
                      xAxes: [{
                        gridLines: {
                          display: false,
                        },
                      }],
                    }
                  }"
                  :styles="{ // parent node
                    position: 'relative',
                    width: '100%',
                    height: '360px' // 'auto',
                  }"
                  :width="534"
                  :height="300"
                  :plugins="[
                    {
                      id: 'my-plugin',
                      beforeInit: function (chart) {
                        chart.legend.afterFit = function() {
                          this.height = this.height + 30;
                        };
                      }
                    }
                  ]"
              />
            </builderall-loader>
          </div>
        </div>
        <div class="ba-mg-x-1">
          <hr class="ba-hr-column">
        </div>
        <div class="ba-container referring-infos">
          <builderall-loader :loading="referring.loading">
            <table class="ba-table ba-md ba-w-100">
              <thead>
                <tr class="ba-flex">
                  <th colspan="3">{{ t.label_url }}</th>
                  <th class="ba-text-right">{{ t.access }}</th>
                  <th class="ba-text-right">{{ t.registration }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!referring.loading && referring.chart.params.current.data.length === 0">
                  <td colspan="3">
                    <builderall-empty-image/>
                  </td>
                </tr>
                <tr v-for="(row, index) in referring.chart.params.current.data" :key="index">
                  <td
                    colspan="3"
                    ba-tooltip-position='bottom'
                    ba-tooltip-color='dark'
                    :ba-tooltip-title="row.url"
                  >
                    <span class="referring-url">{{ row.url }}</span>
                  </td>
                  <td><strong>{{ row.access }}</strong></td>
                  <td><strong>{{ row.conversions }}</strong></td>
                </tr>
              </tbody>
            </table>
          </builderall-loader>
        </div>
      </div>
    </div>

    <ba-franchise-modals-v5 :show_buttons="false" />
  </div>
</template>

<style scoped lang="scss">
  .ba-graphic-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 98% !important;
    .filter-group {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 16px;
      .filter {
        border-radius: 4px;
        border-style: solid;
        border-width: 0px 0px 0px 10px;
       /* background-color: #F8F9FC;
        box-shadow: 1px 2px 15px 0px rgba(0, 0, 0, 0.11);
        */
        justify-content: center;
        padding: 3.4px 9px 2.912px 9px;
        transition: background-color .3s;

        &[ba-tooltip-title]:hover::after {
          text-transform: none;
        }

        span {
          color: #3B5487;
        }
        &.activated {
          border-width: 1px 1px 1px 10px;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .no-text-transform {
    text-transform: none;
  }

    .content_associate_link{
      display: flex;
      border-radius: 20px;
      background: #f5f8fd;
      padding: 16px;
      width: 100%;

      .url_associate{
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: underline;
      }
      .button_copy_link{
        background: none;
        border: none;
        cursor: pointer;

        builderall-icon{
          margin-left: 8px;
          align-items: center;
        --builderall-icon-size: 18px;
        --builderall-icon-color: #425e7d;
        }
      }
    }

  .content_img{
    width: 126px;
    /* margin-top:2rem; */
    img{
      width: 175px;
      border-radius: 50%;
    }
  }
  .hr_column{
    display: flex;
    width: 1px;
    height: 196px;
    align-items: center;
    flex-direction: column;
    background-color: #C4D1E0;;
  }
  .content_img_need_help{
      width: 186px;
      flex-shrink: 0;
      border-radius: 16px;
      border: 1px solid #C4D1E0;
      margin-right: 1rem;
      padding-top: 8px
  }
  .img_need_help{
    width: 162px;
  }

    .text_help{
      font-size: 16px;
      color: #ee9500;
      font-weight: 500;
      text-align: center;
      margin-top: 6px;
    }

    .button_click_here{
      border: none;
      background: none;
      display: flex;
      align-items: center;
      margin-top: 8px;
      margin-bottom: 8px;
      justify-content: flex-end;

      span{
        font-size: 14px;
        color: #0072E1;
        text-decoration: underline;
      }

      builderall-icon{
        margin-left: 4px;
      --builderall-icon-size: 14px;
      --builderall-icon-color: #0072E1;
      }
    }
  @media (max-width: 1600px){
      .url_associate{
         max-width: 30ch;
      }
    }
  .modal_click_here{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding-top: 8rem;
    .img_overlay_click_here{
      position: absolute;
      top: -240px;
      left: 50%;
      width: 75%;
      height: auto;
      transform: translateX(-50%);
      z-index: 1;

    }
  }

  .hr_column_card_earnings{
    display: flex;
    width: 1px;
    height: 159px;
    align-items: center;
    flex-direction: column;
    background-color: #C4D1E0;
  }

  .modal_tutorial{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding-top: 8rem;
  }

  #funnel-of-the-month-card{
    -webkit-box-shadow: 0px 0px 12px 1px rgba(0,0,0,0.1);
    -moz-box-shadow: 0px 0px 12px 1px rgba(0,0,0,0.1);
    box-shadow: 0px 0px 12px 1px rgba(0,0,0,0.1);
    width: 480px !important;
    height: 220px;
    justify-content: center;

    .img-container{
      width: 48%;
      border-radius: 16px;
      display: grid;
      align-items: center;
      justify-content: center;

      img{
        border-radius: 16px;
        -webkit-box-shadow: 0px 0px 12px -3px rgba(0,0,0,0.2);
        -moz-box-shadow: 0px 0px 12px -3px rgba(0,0,0,0.2);
        box-shadow: 0px 0px 12px -3px rgba(0,0,0,0.2);
      }
    }
    .infos-container{
      width: 52%;
    }
  }
  .button_card_funnel{
      background: none;
      border: none;
      color: #0072E1;
      font-weight: 500;
      font-family: Montserrat;
    }

  .tutorial-card{
    border: 1px solid #E4EAF6;
    box-shadow: none;
  }

  .analytics-infos {
    .analytics-infos-tabs {
      margin-bottom: 1rem;
    }
    .analytics-is-active {
      background-color: #99CCFF;
      color: #0080FC;
    }
    .no-hover-tab {
      &:hover {
        cursor: default !important;
        /*color: #425e7d;
        border-top: none;
        background-color: #f6f8fb;*/
      }
    }
    .ba-badge {
      position: absolute;
      margin-left: -12px;
    }
    .ba-purple {
      &::before {
        background-color: #7e1afd;
      }
    }
    .ba-yellow {
      &::before {
        background-color: #ffcc3f;
      }
    }
  }

  .referring-infos {
    width: 60%;
    tbody {
      display: block;
      height: 330px;
      overflow: auto;
    }
    thead, tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed;/* even columns width , fix width of table too*/
    }
    thead tr th:first-child {
      width: 60%;
    }
    .referring-url {
      width: 130px;
      max-width: 130px;
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .ba-card-grid {
    display: grid;
    grid-template-columns: calc(70% - 8px) calc(30% - 8px);
    gap: 16px;
  }


  .ba-hr-conditional:last-child{
    hr{
    display: none;
  }
}
  .ba-custom-scroll{
    overflow-y: hidden;
    overflow-x: auto !important;
    padding: 14px 0px 14px 0px;
    /* .ba-hr-conditional {
      border-right: 1px solid #c4d1e0;
    } */
  }
  .ba-custom-scroll::-webkit-scrollbar-thumb {
    background-color: #b4c4d7;
    border-radius: 8px;
}
.ba-custom-scroll::-webkit-scrollbar {
  height: 8px;
}
.ba-mg-l-10px{
  margin-left: 10px;
}
.m-50 {
  margin: 0px 50px !important
}
.m-16 {
  margin: 0px 16px !important
}

@media (max-width: '1420px') {
  #funnel-of-the-month-card{
    width: 400px !important;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/franchise-system/franchise-index.vue